import React from 'react';
import { Switch } from './switch';
import { cn } from '../../lib/utils';
import { Check, X } from 'lucide-react';

interface VerificationToggleProps {
  isVerified: boolean;
  onToggle: () => void;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
}

const VerificationToggle = ({ 
  isVerified, 
  onToggle, 
  size = 'md',
  disabled = false
}: VerificationToggleProps) => {
  const circleSize = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-6 w-6' : 'h-5 w-5';
  const bgColor = isVerified ? 'bg-bytesplash-blue' : 'bg-gray-300';
  
  return (
    <div className="flex items-center gap-1 justify-center">
      <Switch 
        checked={isVerified} 
        onCheckedChange={onToggle}
        disabled={disabled}
        className={cn(
          'relative peer inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer border-2 border-transparent rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
          bgColor
        )}
      />
      <div className={cn(
        'rounded-full flex items-center justify-center',
        circleSize,
        isVerified ? 'text-white bg-bytesplash-blue' : 'text-gray-500 bg-gray-300'
      )}>
        {isVerified ? <Check size={12} /> : <X size={12} />}
      </div>
    </div>
  );
};

export default VerificationToggle;